module.exports = __webpack_public_path__ + "static/media/DSC03751.7389ce9b.jpg";